import AutosaveSuccess from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import { get, includes, isNil, toLower } from "lodash";
import React, { useEffect, useState } from "react";
import DealComplianceModal from "../../../common/js/components/DealComplianceModal";
import FormTitle from "../../../common/js/components/FormTitle";
import Comments from "../comments/CommentsContainer";
import CompCommentBlock from "../comments/CompCommentBlock";
import comments_constants from "../comments/constants";
import ListingCommentBlock from "../comments/ListingCommentBlock";
import { comp_contact_options } from "../contact/constants";
import ContactInformation from "../contact/ContactContainer";
import DealForm from "../deal/DealForm";
import InvoiceDetail from "../deal/InvoiceDetail";
import TotalConsiderationForm from "../deal/TotalConsiderationForm";
import DocumentDrop from "../documents/DocumentDropContainer";
import FinancialInformation from "../listing/FinancialInformation";
import ListingForm from "../listing/ListingForm";
import CondoForm from "../property/CondoForm";
import EducationalForm from "../property/EducationalForm";
import HospitalityForm from "../property/HospitalityForm";
import IndustrialForm from "../property/IndustrialForm";
import LandForm from "../property/LandForm";
import MixedUseForm from "../property/MixedUseForm";
import MultifamilyForm from "../property/MultifamilyForm";
import ParkingInfoForm from "../property/ParkingInfoForm";
import PortfolioForm from "../property/PortfolioForm";
import Property from "../property/Property";
import PropertyUpdateModalContainer from "../property/PropertyUpdateModalContainer";
import ReligiousForm from "../property/ReligiousForm";
import RetailForm from "../property/RetailForm";
import LeaseDetailForm from "./LeaseDetailForm";

const OutsideCompComponent = (props) => {
    const [panels, setPanels] = useState({
        listingFinancial: includes(["Outside Draft", "Outside"], props.deal.compStatus)
            ? false
            : get(props.deal, "listing.listingName") === null ||
              includes(props.expandedErrorPanels, "listingFinancial"),
        listingInformation: includes(["Outside Draft", "Outside"], props.deal.compStatus)
            ? false
            : get(props.deal, "listing.listingName") === null ||
              includes(props.expandedErrorPanels, "listingInformation"),
        property: includes(props.expandedErrorPanels, "property"),
    });

    const togglePanel = (panel, open, checkErrorPanels) => {
        const updatedPanels = { ...panels };
        updatedPanels[panel] = open;
        setPanels(updatedPanels);
        if (!isNil(checkErrorPanels)) {
            props.toggleCheckErrorPanels(checkErrorPanels);
        }
    };

    const openGroupOfPanels = (updatedPanels) => {
        setPanels(updatedPanels);
    };

    const handleTriggerPropertySearchModal = (e) => {
        e.stopPropagation();
        props.togglePropertySearchModal(true);
    };

    const {
        checkErrorPanels,
        deal,
        determineDocumentOptions,
        disableInputs,
        documentWarning,
        errors,
        expandedErrorPanels,
        handleAddArrayElement, // (path)
        handleAutocalculateTiSf,
        handleConfirmWarning,
        handleDeleteArrayElement,
        handleDocumentWarning,
        handleInput,
        handleObjectPropertyChange,
        handleUpdateArrayElement,
        id,
        listingAttributes,
        restrictViewDocuments,
        toggleTerminationDoc,
    } = props;

    const fromListing = get(deal, "fromListing", false);

    useEffect(() => {
        if (checkErrorPanels === true) {
            let updatedPanels = {};
            if (includes(expandedErrorPanels, "property") && panels.property === false) {
                updatedPanels = { ...updatedPanels, property: true };
            }
            if (fromListing || includes(expandedErrorPanels, "listingInformation")) {
                updatedPanels = { ...updatedPanels, listingInformation: true };
            }
            if (fromListing || includes(expandedErrorPanels, "listingFinancial")) {
                updatedPanels = { ...updatedPanels, listingFinancial: true };
            }

            openGroupOfPanels(updatedPanels);
            props.toggleCheckErrorPanels(false);
        }
    }, [expandedErrorPanels]);

    return (
        <div>
            <DocumentDrop
                entityKey={id}
                type="comp"
                documentTypes="comp"
                formDisabled={disableInputs}
                errors={errors.documents}
                restrictPreview={restrictViewDocuments}
                toggleTerminationDoc={toggleTerminationDoc}
                options={determineDocumentOptions}
                parentType="COMP"
                stateCode={get(deal, "listing.property.primaryAddress.city.state.stateCode", null)}
            />
            <div>
                <Accordion
                    expanded={panels.property}
                    onChange={() => togglePanel("property", !panels.property, false)}
                    style={{ marginBottom: "35px" }}
                >
                    {(get(props.userProfile, "role") === "dataAdmin" && get(props.listing, "status") === "Active") ||
                    disableInputs === false ? (
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="expansionPanelContentContainer">
                                <AutosaveSuccess className="waterloo" style={{ paddingTop: "4px" }} />
                                <div>
                                    Property Information
                                    <EditIcon
                                        style={{
                                            width: "18px",
                                            height: "18px",
                                            fill: "#233a47",
                                            paddingLeft: "5px",
                                        }}
                                        onClick={(e) => handleTriggerPropertySearchModal(e)}
                                    />
                                    <div>
                                        <small className="entityIDText">
                                            Property ID: {deal.listing.property.propertyKey}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                    ) : (
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="expansionPanelContentContainer">
                                <AutosaveSuccess className="waterloo" />
                                <div>
                                    Property Information
                                    <div>
                                        <small className="entityIDText">
                                            Property ID: {deal.listing.property.propertyKey}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                    )}
                    <Divider />
                    <AccordionDetails>
                        <Property
                            attributes={get(deal, "listing.property.propertyAttributes", {})}
                            property={get(deal, "listing.property", {})}
                            handleInputChange={(f, v) => handleInput("listing." + f, v)}
                            errors={errors}
                            handleAddArrayElement={(path) => props.handleAddArrayElement("listing." + path)}
                            handleDeleteArrayElement={(path, index) =>
                                props.handleDeleteArrayElement("listing." + path, index)
                            }
                            handleUpdateArrayElement={(arrayPath, index, field, value) =>
                                props.handleUpdateArrayElement("listing." + arrayPath, index, field, value)
                            }
                            deal={deal}
                            prefix="listing."
                            disableInputs={get(deal, "listing.property.propertyKey", null) !== null}
                            propertyType={
                                get(deal, "listing.property.propertyType", null) !== null
                                    ? get(deal, "listing.property.propertyType", null)
                                    : get(deal, "propertyType", null)
                            }
                            location={props.location}
                        />
                    </AccordionDetails>
                </Accordion>
                <div>
                    <PropertyUpdateModalContainer {...props} formType="comp" />
                </div>
            </div>

            {/*                        Listing Information                        */}

            {get(deal, "listing.listingName") !== undefined && (
                <React.Fragment>
                    <Accordion
                        expanded={panels.listingInformation}
                        onChange={() => togglePanel("listingInformation", !panels.listingInformation, false)}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="expansionPanelContentContainer">
                                <AutosaveSuccess className="waterloo" />
                                <div>
                                    Listing Information
                                    <div>
                                        <small className="entityIDText">LISTING ID: {deal.listing.listingKey}</small>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <ListingForm
                                {...props}
                                isOutside={includes(["Outside Draft", "Outside"], get(deal, "compStatus", ""))}
                                disabled={disableInputs}
                                listing={get(deal, "listing", {})}
                                listingBrokers={get(deal, "listing.listingBrokers", [{}])}
                                propertyType={get(deal, "listing.attributes.useType", null)}
                                errors={get(errors, "listing", {})}
                                showListingExpiration={false}
                                handleInputChange={(field, value) => handleInput(field, value)}
                                handleAddArrayElement={(path, obj) => handleAddArrayElement("listing." + path, obj)}
                                handleDeleteArrayElement={(path, index) => handleDeleteArrayElement(path, index)}
                                handleUpdateArrayElement={(path, index, field, value) =>
                                    handleUpdateArrayElement(path, index, field, value)
                                }
                                compStatus={get(deal, "compStatus", null)}
                            />
                            <Divider />
                            <MixedUseForm
                                {...props}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                data={listingAttributes}
                                dataPathPrefix="listing.attributes"
                                errors={get(errors, "attributes", {})}
                            />
                            <Divider />
                            <PortfolioForm
                                {...props}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                data={listingAttributes}
                                dataPathPrefix="listing.attributes"
                                errors={get(errors, "attributes", {})}
                            />
                            <Divider />
                            <CondoForm
                                {...props}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                data={listingAttributes}
                                dataPathPrefix="listing.attributes"
                                errors={get(errors, "attributes", {})}
                            />
                            <Divider />
                            <FormTitle title="Parking Information" />
                            <ParkingInfoForm
                                {...props}
                                context="listing"
                                data={listingAttributes}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                errors={get(errors, "listing.attributes", {})}
                            />
                            {toLower(deal.propertyType) === "industrial" && (
                                <div>
                                    <Divider />
                                    <FormTitle title="Industrial Information" />
                                    <IndustrialForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "land" && (
                                <div>
                                    <Divider />
                                    <FormTitle title="Land Information" />
                                    <LandForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "multifamily" && (
                                <div>
                                    <Divider />
                                    <FormTitle title="Multifamily Information" />
                                    <MultifamilyForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "retail" && (
                                <div>
                                    <Divider />
                                    <FormTitle title="Retail Information" />
                                    <RetailForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                        dataPathPrefix="listing.attributes"
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "hospitality" && (
                                <div>
                                    <Divider />
                                    <FormTitle title="Hospitality Information" />
                                    <HospitalityForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "religious" && (
                                <div>
                                    <Divider />
                                    <FormTitle title="Religious Information" />
                                    <ReligiousForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                        listingStatus={get(deal, "listing.status", null)}
                                        transactionType={deal.transactionType}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "educational" && (
                                <div>
                                    <Divider />
                                    <FormTitle title="Educational Information" />
                                    <EducationalForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            <ListingCommentBlock
                                errors={errors}
                                handleInputChange={handleInput}
                                data={get(deal, "listing")}
                                disableInputs={true}
                                showFormTitle={true}
                            />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={panels.listingFinancial}
                        onChange={() => togglePanel("listingFinancial", !panels.listingFinancial, false)}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="expansionPanelContentContainer">
                                <AutosaveSuccess className="waterloo" style={{ paddingTop: "4px" }} />
                                <div>Listing Financial Information</div>
                            </div>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <FinancialInformation
                                {...props}
                                disableInputs={disableInputs}
                                listing={deal.listing}
                                errors={get(errors, "listing", {})}
                                handleInputChange={(field, value) => handleInput(field, value)}
                                compStatus={get(deal, "compStatus", null)}
                            />
                        </AccordionDetails>
                    </Accordion>
                </React.Fragment>
            )}

            {/*                        Comp Information                        */}

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div>
                        Comp Information
                        <div>
                            <small className="entityIDText">Deal ID: {deal.dealKey}</small>
                        </div>
                    </div>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <DealForm
                        {...props}
                        disableInputs={disableInputs}
                        transactionType={deal.transactionType}
                        handleInput={(field, value) => handleInput(field, value)}
                        errors={errors}
                    />
                </AccordionDetails>
            </Accordion>

            {/*                        Total Consideration                        */}

            {toLower(deal.transactionType) !== "sale" && (
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Total Consideration</AccordionSummary>
                    <Divider />
                    <AccordionDetails>
                        <TotalConsiderationForm
                            {...props}
                            disableInputs={disableInputs}
                            transactionType={deal.transactionType}
                            handleAutocalculateTiSf={handleAutocalculateTiSf}
                            handleTotalConsiderationAmountChange={(value) =>
                                handleInput("totalConsiderationAmount", value)
                            }
                        />
                        <InvoiceDetail {...props} disableInputs={disableInputs} />
                    </AccordionDetails>
                </Accordion>
            )}

            {/* Lease Details */}

            {toLower(deal.transactionType) === "lease" && (
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Lease Details</AccordionSummary>
                    <Divider />
                    {deal.transactionType && (
                        <AccordionDetails>
                            <LeaseDetailForm
                                {...props}
                                onChange={(event) => handleObjectPropertyChange("deal", event)}
                                leaseDetail={deal}
                                disableInputs={disableInputs}
                                transactionType={deal.transactionType}
                                useType={deal.propertyType}
                                errors={errors}
                                handleAutocalculateTiSf={handleAutocalculateTiSf}
                            />
                        </AccordionDetails>
                    )}
                </Accordion>
            )}

            {/* Comp Contact Information */}

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Comp Contact Information</AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <ContactInformation
                        {...props}
                        handleChange={(field, value, index) =>
                            handleInput(`propertyAttributes.contacts[${index}].${field}`, value)
                        } //todo
                        handleAdd={() => handleAddArrayElement("propertyAttributes.contacts")}
                        handleDelete={(index) => handleDeleteArrayElement("propertyAttributes.contacts", index)}
                        contacts={get(deal, "propertyAttributes.contacts", [])}
                        contactTypeOptions={comp_contact_options}
                        addButtonText="Add Contact Information"
                        includeInvoiceRecipientCheckbox={
                            !(
                                get(deal, "compStatus", null) === "Outside Draft" ||
                                get(deal, "compStatus", null) === "Outside"
                            )
                        }
                        maxContacts={5}
                        displayWhenEmpty={true}
                        companyFieldAvailable={true}
                        errors={errors}
                        hideTitle={true}
                        freeFormCompany={true}
                    />
                </AccordionDetails>
            </Accordion>

            <CompCommentBlock data={deal} disableInputs={disableInputs} handleInputChange={handleInput} />
            <Comments parentRecordType={comments_constants.COMP_PARENT_RECORD_TYPE} parentRecordId={id} />

            <DealComplianceModal
                documentWarning={documentWarning}
                handleDocumentWarning={handleDocumentWarning}
                handleConfirmWarning={handleConfirmWarning}
                documentTypeKey={"comp"}
            />
        </div>
    );
};

export default OutsideCompComponent;
